import { render, staticRenderFns } from "./OTextareaInput.vue?vue&type=template&id=ba04b638&scoped=true&"
import script from "./OTextareaInput.vue?vue&type=script&lang=js&"
export * from "./OTextareaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba04b638",
  null
  
)

export default component.exports